/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { StringMap, TOptions } from 'i18next';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../i18n';

interface ValidationTranslationOptions extends StringMap {
  field?: string;
  maxLength?: string | number;
  minLength?: string | number;
  moreThan?: string | number;
  lessThan?: string | number;
  maxDate?: string;
  minDate?: string;
}

export const useValidationTranslation = () => {
  const { t, ready, i18n } = useTranslation([Namespaces.Validation]);

  // translate with default rules
  const vtr = useCallback(
    (key: string, options?: TOptions<ValidationTranslationOptions>) =>
      t([`${Namespaces.Validation}:rules.${key}`, key], options),
    [t],
  );

  // translate with custom messages for field -> rule
  const vtf = useCallback(
    (key: string, rule: string, options?: TOptions<ValidationTranslationOptions>) =>
      t([`${Namespaces.Validation}:validation.${key}.${rule}`, `${Namespaces.Validation}:rules.${rule}`], options),
    [t],
  );

  return { t, vtr, vtf, ready, i18n };
};
